import { Public } from '../types';
import Utility from '../utilities/Utility';

/**
 * User level feature flags that can be toggled in the @see HomeFeaturesPage.
 *
 * @note @see DesignRootSettings.features for the @see Design level features.
 */
export enum FeatureFlag {
  /** Banner Message node feature */
  banner = 'banner',
  /** D1 Import feature */
  d1import = 'd1import',
  /** Inventory feature */
  inventory = 'inventory',
  /** Rich Text node feature */
  richText = 'richTextNode',
  /** Standalone Mode feature */
  standaloneMode = 'standaloneMode',
  /** WalkMe Widget feature */
  walkMeWidget = 'walkMeWidget',
  /** Wizard Configuration feature */
  wizardConfig = 'wizardConfig'
}

/** Public interface of @see FeatureFlagService. */
export type IFeatureFlagService = Public<FeatureFlagService>;

/** Service to handle feature flag related actions. */
export class FeatureFlagService {
  /** Checks if a feature is on (`true`) or off (`false`). */
  isFeatureOn(flag: FeatureFlag): boolean {
    return Utility.getCookieBool(flag);
  }

  /** Sets whether a feature is on (`true`) or off (`false`). */
  setFeature(flag: FeatureFlag, value: boolean): boolean {
    Utility.setCookie(flag, value, 90);
    return value;
  }
}
